import "./ServicesContent.css";
// import "./cards.css";
import Title from "../Title/title";
import ButtonServ from "../Button/ButtonServ";

function ServicesContent() {
  return (
    <div className="content" id="ServicesContent">
      <div className="heading">
        <Title title="Услуги" translate="Services" />
      </div>

      <div className="container-servise">
        {/* Карточка 1: Бровист */}
        <div className="item-servise card">
          <div className="accent-badge">Популярно</div>
          <div className="item-servise-content">
            <div className="servise-content">
              <div className="service-header">
                <h4 className="heading-servise">Бровист</h4>
                <div className="service-icon">✨</div>
              </div>

              <p className="text-ab-pp">
                В качестве мастера-бровиста я уделяю особое внимание
                формированию идеальных бровей, которые подчеркивают
                индивидуальность каждого клиента.
              </p>
              <p className="text-ab-pp">
                Моя цель — создать естественный и гармоничный вид, который будет
                радовать вас каждый день.
              </p>

              <div className="service-stats">
                {/* <div className="stat-item">
                  <span className="stat-number">7+</span>
                  <span className="stat-label">лет опыта</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">95%</span>
                  <span className="stat-label">клиентов возвращаются</span>
                </div> */}
              </div>
            </div>
          </div>

          <div className="services-list">
            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Оформление бровей (архитектура, коррекция, окрашивание)
              </p>
              <p className="text-ab-pp item time">30 мин</p>
              <p className="text-ab-pp item price">1 500 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Коррекция бровей (трейдинг, пинцет, воск)
              </p>
              <p className="text-ab-pp item time">15 мин</p>
              <p className="text-ab-pp item price">от 700 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Мужская коррекция бровей
              </p>
              <p className="text-ab-pp item time">15 мин</p>
              <p className="text-ab-pp item price">700 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Удаление нежелательных волос на лице
              </p>
              <p className="text-ab-pp item time">20 мин</p>
              <p className="text-ab-pp item price">от 500 ₽</p>
            </div>
          </div>

          <div className="button-div">
            <a
              href="https://n1274061.yclients.com/company/687678/personal/select-services?o=m1980662"
              target="_blank"
              rel="noreferrer"
              className="booking-link"
            >
              <ButtonServ>Записаться онлайн</ButtonServ>
            </a>
            <p className="booking-note">Бронирование через систему YClients</p>
          </div>
        </div>

        {/* Карточка 2: Уход за ресницами */}
        <div className="item-servise card">
          <div className="accent-badge premium">Популярно</div>

          <div className="item-servise-content">
            <div className="servise-content">
              <div className="service-header">
                <h4 className="heading-servise">
                  Уход за ресницами{" "}
                  {/* <span className="gradient-text">• Люкс</span> */}
                </h4>
                <div className="service-icon">🌟</div>
              </div>

              <p className="text-ab-pp">
                Ламинирование ресниц — это моя страсть. Я
                знаю, как сделать ваши ресницы более выразительными и
                ухоженными.
              </p>
              <p className="text-ab-pp">
                Эта процедура не только придает объем и изгиб, но и укрепляет
                ресницы, делая их более здоровыми и красивыми.
              </p>

              <div className="service-tag-list">
                <span className="service-tag">Безопасно</span>
                <span className="service-tag">Долговечно</span>
                <span className="service-tag">Гипоаллергенно</span>
              </div>
            </div>
          </div>

          <div className="services-list">
            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Окрашивание ресниц
              </p>
              <p className="text-ab-pp item time">15 мин</p>
              <p className="text-ab-pp item price">500 ₽</p>
            </div>

            <div className="item-menu highlighted">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">🔥</span>
                Ламинирование ресниц (эффект 1,5-3 месяца)
              </p>
              <p className="text-ab-pp item time">1 ч</p>
              <p className="text-ab-pp item price">3 000 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Velvet ресниц (2-3 месяца)
              </p>
              <p className="text-ab-pp item time">1 ч</p>
              <p className="text-ab-pp item price">3 500 ₽</p>
            </div>
          </div>

          <div className="button-div">
            <a
              href="https://n1274061.yclients.com/company/687678/personal/select-services?o=m1980662"
              target="_blank"
              rel="noreferrer"
              className="booking-link"
            >
              <ButtonServ>
                <span className="button-content">
                  <span>Записаться онлайн</span>
                </span>
              </ButtonServ>
            </a>
            <p className="booking-note">Бронирование через систему YClients</p>
          </div>
        </div>

        {/* Карточка 3: Перманентный макияж */}
        <div className="item-servise card">
          <div className="accent-badge">Популярно</div>

          <div className="item-servise-content">
            <div className="servise-content">
              <div className="service-header">
                <h4 className="heading-servise">
                  Перманентный макияж{" "}
                  {/* <span className="gradient-text">• Искусство</span> */}
                </h4>
                <div className="service-icon">🎨</div>
              </div>

              <p className="text-ab-pp">
                Современные техники перманентного макияжа создают идеальный
                образ на каждый день. Я использую только качественные пигменты
                премиум-класса.
              </p>
              <p className="text-ab-pp">
                Моя задача — подчеркнуть вашу красоту, сохраняя максимальную
                естественность и индивидуальность.
              </p>

              {/* <div className="service-benefits">
                <div className="benefit">
                  <div className="benefit-icon">✓</div>
                  <span>Использую анестезию</span>
                </div>
                <div className="benefit">
                  <div className="benefit-icon">✓</div>
                  <span>Сертифицированные материалы</span>
                </div>
              </div> */}
            </div>
          </div>

          <div className="services-list">
            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Брови в аппаратной технике "Пудра"
              </p>
              <p className="text-ab-pp item time">1 ч 30 мин</p>
              <p className="text-ab-pp item price">10 000 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Брови в мануальной технике "Волоски"
              </p>
              <p className="text-ab-pp item time">1 ч 30 мин</p>
              <p className="text-ab-pp item price">10 000 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Губы в бесконтурной "Акварельной" технике
              </p>
              <p className="text-ab-pp item time">1 ч 30 мин</p>
              <p className="text-ab-pp item price">8 000 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Веки в аппаратной технике "Межресничка"
              </p>
              <p className="text-ab-pp item time">1 ч</p>
              <p className="text-ab-pp item price">8 000 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Коррекция перманентного макияжа
              </p>
              <p className="text-ab-pp item time">1 ч 30 мин</p>
              <p className="text-ab-pp item price">5 000 ₽</p>
            </div>

            <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Удаление татуажа ремувером
              </p>
              <p className="text-ab-pp item time">1 ч</p>
              <p className="text-ab-pp item price">3 000 ₽ – 4 500 ₽</p>
            </div>

             <div className="item-menu">
              <p className="text-ab-pp-item item">
                <span className="service-bullet">•</span>
                Консультация
              </p>
              <p className="text-ab-pp item time">15 мин</p>
              <p className="text-ab-pp item price">Бесплатно</p>
            </div>
          </div>

          <div className="button-div">
            <a
              href="https://n1274061.yclients.com/company/687678/personal/select-services?o=m1980662"
              target="_blank"
              rel="noreferrer"
              className="booking-link"
            >
              <ButtonServ variant="primary">Записаться онлайн</ButtonServ>
            </a>
            <p className="booking-note">Бронирование через систему YClients</p>
          </div>
        </div>
      </div>

      {/* Дополнительная информация */}
      <div className="additional-info">
        <div className="info-card">
          <div className="info-icon">💎</div>
          <h3 className="info-title">Гарантия качества</h3>
          <p className="info-text">
            Использую только профессиональные материалы премиум-класса
          </p>
        </div>

        <div className="info-card">
          <div className="info-icon">🕒</div>
          <h3 className="info-title">Гибкий график</h3>
          <p className="info-text">
            Работаю с 10:00 до 20:00, включая выходные дни
          </p>
        </div>

        <div className="info-card">
          <div className="info-icon">📍</div>
          <h3 className="info-title">Удобное расположение</h3>
          <p className="info-text">Студия находится на улице Весенняя, 31</p>
        </div>
      </div>
    </div>
  );
}

export default ServicesContent;
